module.exports = __webpack_public_path__ + "img/google-store.af961bc5.png";